import React,{Component} from 'react';
import "./style.less"
import {NavBar} from "antd-mobile";
export default class InvoiceProtocol extends Component{
    constructor(props) {
        super(props);
    }
    render(){
        return(
            <div className="invoiceProtocol">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()} />}
                >
                    开具发票协议

                </NavBar>
                <div className="content">
                   <p className="tit">开具发票协议</p>
                    <div className="">1、 个人发票只限开具实际乘车人信息，需要填写正确的乘车人姓名，税号无需填写；企业发票需要填写正确的企业单位名称及税号，否则无法开具有效发票；如因税号填写失误造成发票失效，我平台不承担相关责任。</div>
                    <div className="">2. 平台支持每笔订单单独开具发票，也支持多笔订单一起开具发票，用户请根据需要选择。请注意，多笔订单一起申请发票时，只会生成一张发票。</div>
                    <div className="">3.纸质发票申请时需要支付邮费,<span className="pic">收费标准为10元/张。</span></div>
                    <div>4.发票申请成功后，将于5到7个工作日内完成开票。</div>
                    <div>5.如需详细的行程单请联系客服。</div>
                </div>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Invoice/InvoiceProtocol/index.js